import styles from "./ChannelReconnectBanner.module.css";

type Props = {
  // Display names of the channels that came unlinked, e.g. ["WhatsApp"].
  channelNames: ReadonlyArray<string>;
  // Only the owner can relink; everyone else is told who to ask.
  canReconnect: boolean;
  onReconnect: () => void;
};

// A channel the customer connected has come unlinked (WhatsApp logs a linked
// device out when the main phone goes quiet). The agent can't say so itself
// over a dead channel, so the dashboard has to.
export const ChannelReconnectBanner = ({ channelNames, canReconnect, onReconnect }: Props): JSX.Element => {
  const names = channelNames.join(" and ");
  return (
    <div className={styles.banner} role="status" data-testid="channel-reconnect-banner">
      <span className={styles.icon} aria-hidden>
        ⚠
      </span>
      <div className={styles.text}>
        <strong>{names} unlinked your agent.</strong>
        <span>
          {" "}
          People can't reach it there until it's reconnected.{" "}
          {canReconnect ? "It takes about a minute." : "Ask the agent's owner to reconnect it from their dashboard."}
        </span>
      </div>
      {canReconnect ? (
        <button type="button" className={styles.action} onClick={onReconnect} data-testid="channel-reconnect-banner-action">
          Reconnect
        </button>
      ) : null}
    </div>
  );
};
